
import TabbedNavigation from "./TabbedNavigation";
import CompanyProfileTab from "./CompanyProfileTab";
import MyProfileTab from "./MyProfileTab";
import PasswordTab from "./PasswordTab";
import NotificationTab from "./NotificationTab";
import MaintainRolesTab from "./MaintainRolesTab";

const AdminSettingsPage = () => {
  const tabs = [
    {
      id: "companyProfile",
      label: "Company's Profile",
      content: <CompanyProfileTab />
    },
    {
      id: "myProfile",
      label: "My Profile",
      content: <MyProfileTab />
    },
    {
      id: "password",
      label: "Password",
      content: <PasswordTab />
    },
    {
      id: "notification",
      label: "Notification",
      content: <NotificationTab />
    },
    {
      id: "maintainRoles",
      label: "Maintain Roles",
      content: <MaintainRolesTab />
    },
  ];

  return (
    <div className="">
      <div className="mx-3">
        <TabbedNavigation tabs={tabs} />
      </div>
    </div>
  );
};

export default AdminSettingsPage;





// import React, { useState } from "react";
// import TabbedNavigation from "./TabbedNavigation";
// import { TabbedLinks } from "../../../utils/TabbedLinks";

// const AdminSettingsPage = () => {
//   const [activeTab, setActiveTab] = useState(null);
//   const tabs = require("../../../utils/TabbedLinks").default;

//   const handleTabClick = (tabId) => {
//     setActiveTab(tabId);
//   };

//   const renderTabContent = () => {
//     // Render tab content based on the active tab
//   };

//   return (
//     <div>
//       <h1>Admin Settings Page</h1>
//       <TabbedNavigation activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />

//       <div className="mt-4">
//         <TabbedLinks activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />
//         <div className="p-4 bg-gray-100">{renderTabContent()}</div>
//       </div>
//     </div>
//   );
// };

// export default AdminSettingsPage;



// import React, { useState } from "react";
// import TabbedNavigation from "./TabbedNavigation";
// import { TabbedLinks } from "../../../utils/TabbedLinks";


// const AdminSettingsPage = () => {
//   const [activeTab, setActiveTab] = useState(null);
//   const tabs = require("../../../utils/TabbedLinks").default;

//   const handleTabClick = (tabId) => {
//     setActiveTab(tabId);
//   };

//   const renderTabContent = () => {
//     // Render tab content based on the active tab
//   };

//   return (
//     <div>
//       <h1>Admin Settings Page</h1>
//       <TabbedNavigation activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />

//       <div className="mt-4">
//         <TabbedLinks activeTab={activeTab} handleTabClick={handleTabClick} tabs={tabs} />
//         <div className="p-4 bg-gray-100">{renderTabContent()}</div>
//       </div>
//     </div>
//   );
// };

// export default AdminSettingsPage;











// import React from 'react'
// import TabbedNavigation from './TabbedNavigation';

// const AdminSettingsPage = () => {
//   return (
//     <div className="">
//       <div className="flex">
//         <div className="w-2/5">
//           <h1>Settings</h1>
//           <TabbedNavigation />
//         </div>

//         <div className="w-3/5">
//           <h1>Company's Profile</h1>          
//         </div>
//       </div>
//     </div>
//   )
// }

// export default AdminSettingsPage;
